/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function SubmitAction({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/CreditCardCapture/Ready/Content/SubmitAction"
  
}) {
let creditCardCaptureIsSubmittingValueData = fromData.useDataFormat({ viewPath,
context: 'credit_card_capture',
path: 'isSubmitting',
format: fromHelpers.isDisabled,
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 alignSelf="flex-end"
 marginTop={dtSpaceL}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 data="payment.valid"
 data="credit_card_capture.isSubmitting"
 format="helpers.js isDisabled"
 disabled={undefined}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save card"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}